import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { IC_TRASH, IC_CAMERA } from '../../../../Assets/images';
import { ProfileImageUploadStyled } from './ProfileImageUploadStyled';
import { getImageUrlWithSize } from '@common/Utility/common-utils';

const ProfileImageUpload = (props) => {
  return (
    <>
      <ProfileImageUploadStyled className={props?.customClass}>
        <div className="profile-wrapper">
          <div className="profile-pic">
            {props?.profilePicData ? (
              <Image src={props?.profilePicData} alt="Picture of the author" width={100} height={100} unoptimized/>
            ) : (
              <div className="member-image avtar-name">
                {props?.userData?.extension?.find((item) => item.url === 'nameInitials')?.valueString}
              </div>
            )}
            <div className="p-image">
              {props.profilePicData && props.isDeleteEnable && !props.isDefaultImage && (
                <div className="p-icon" onClick={props?.deleteImg}>
                  <Image src={IC_TRASH} alt="Picture of the author" width={38} height={38} className="upload-pic" />
                </div>
              )}
              <Image src={IC_CAMERA} alt="Picture of the author" width={38} height={38} />
              <input
                className="file-upload"
                type="file"
                accept="image/*"
                onChange={props?.changeHandler}
                name={props?.name}
              />
            </div>
          </div>
        </div>
        {props?.isInvalid && <div className="invalid-feedback d-block">{props?.errorMessage}</div>}
      </ProfileImageUploadStyled>
    </>
  );
};

ProfileImageUpload.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  isDeleteEnable: PropTypes.bool,
  profilePicData: PropTypes.any,
  changeHandler: PropTypes.func,
  deleteImg: PropTypes.func,
  isDefaultImage: PropTypes.bool,
  customClass: PropTypes.string,
  userData: PropTypes.any,
  isInvalid: PropTypes.any,
  errorMessage: PropTypes.string,
};

ProfileImageUpload.defaultProps = {
  label: '',
};

export default ProfileImageUpload;
